export const phoneRegexp = /^(\+375) \((29|25|44|33)\) (\d{3})-(\d{2})-(\d{2})$/
// eslint-disable-next-line max-len
export const email = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

// гггг-мм-дд
// export const birthday = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/
export const birthday = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/
export const card = /^[0-9]{7}$/
export const card2 = /^[0-9]{7}(?:[0-9]{6})?$/
export const phoneCode = /^[0-9]{4}$/
